const API_BASE = import.meta.env.VITE_API_BASE;

/**
 * Submit a contact form message.
 * @param {{ name: string, email: string, subject: string, message: string }} payload
 * @returns {Promise<void>} Resolves on success, rejects with Error on failure.
 */
export async function submitContactForm(payload) {
  const res = await fetch(`${API_BASE}/contact`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || `Request failed (${res.status})`);
  }
}
